import AdyenSettings from './AdyenSettings';

export default AdyenSettings;